import { FacerevealResult } from "../models/Result";
import { extractObjectKey, extractSearchedImage } from "../utils/stringUtils";
import { fetchAuthSession } from "@aws-amplify/auth";

export const useCompare = () => {
  const onCompareFaces = async (
    toCompare: FacerevealResult,
    fileName: string,
  ) => {
    const photoToCompare = extractObjectKey(toCompare.image_key);
    const searchedImage = extractSearchedImage(toCompare.image_key);

    try {
      const userData = await fetchAuthSession();
      const tokenValue = userData.tokens?.idToken?.toString() || "";

      const response = await fetch(
        "https://uzq3bb3ufd.execute-api.us-east-1.amazonaws.com/default/",
        {
          method: "POST",
          body: JSON.stringify({
            searchedImage,
            imageKey: photoToCompare,
            fileName,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: tokenValue,
          },
        },
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Face comparison failed");
      }
      const rekognitionResult = JSON.parse(data.body);
      // console.log("Rekognition result: ", rekognitionResult);
      return rekognitionResult;
    } catch (error) {
      console.error("Error comparing faces:", error);
      return null;
    }
  };

  return { onCompareFaces };
};
